import { render } from "./Footer.vue?vue&type=template&id=1b655a36&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=1b655a36&scoped=true&lang=css"

import exportComponent from "/home/runner/work/HexaHome/HexaHome/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.45_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b655a36"]])

export default __exports__